// all the actions related to booking is declared here

export const ADD = 'booking/add';
export const DELETE = 'booking/delete';